export default __webpack_public_path__ + "static/media/kpi.02fbed65.png";